import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearch } from "@tanstack/react-router";
import { boolean, object } from "decoders";
import { useEffect } from "react";
import { useAnalytics } from "use-analytics";
import PageContent from "~/client/components/PageContent";
import PageHeading from "~/client/components/PageHeading";
import { useExtensionContext } from "~/client/contexts/ExtensionContext";
import useImportRecipeFromExtension from "~/client/hooks/useImportRecipeFromExtension";
import { DataBlock, Paragraph } from "./styled";
const searchDecoder = object({
    enabled: boolean,
});
const ImportRecipePage = () => {
    const analytics = useAnalytics();
    useEffect(() => {
        analytics.page({ title: "Import Recipe" });
    }, [analytics]);
    const rawSearch = useSearch({ strict: false });
    const parsedSearch = searchDecoder.value(rawSearch);
    const isPageOpenedByExtension = (parsedSearch === null || parsedSearch === void 0 ? void 0 : parsedSearch.enabled) === true;
    const { isInstalled } = useExtensionContext();
    const { data, isError, isPending } = useImportRecipeFromExtension({
        enabled: isPageOpenedByExtension && isInstalled === true,
    });
    return (_jsxs(PageContent, { children: [_jsx(PageHeading, { children: "Import Recipe" }), _jsx("div", { children: isInstalled === null ? null : isInstalled === false ? (_jsx(Paragraph, { children: "In order to import recipes, the extension must be installed and enabled." })) : isPageOpenedByExtension === false ? (_jsx(Paragraph, { children: "Use the extension to import recipes." })) : isPending ? (_jsx(Paragraph, { children: "Loading\u2026" })) : isError ? (_jsx(Paragraph, { children: "There was an error importing the recipe from the extension. Please close this window and try again." })) : (_jsx(DataBlock, { children: JSON.stringify(data, undefined, 2) })) })] }));
};
export default ImportRecipePage;
